// @ts-nocheck
import {useQuery} from "@tanstack/react-query";
import {getLotteryResourcesService} from "../services/getLotteryResources.service";

// Mock data for development when API is down
const mockLotteryData = {
  sorteos: [
    {id: 1, hora: "09:00 AM"},
    {id: 2, hora: "10:00 AM"},
    {id: 3, hora: "11:00 AM"},
    {id: 4, hora: "12:00 PM"},
    {id: 5, hora: "01:00 PM"},
    {id: 6, hora: "02:00 PM"},
    {id: 7, hora: "03:00 PM"},
    {id: 8, hora: "04:00 PM"},
    {id: 9, hora: "05:00 PM"},
  ],
  fichas: Array.from({length: 36}, (_, i) => ({
    id: i + 1,
    numero: i + 1,
    nombre: `Animal ${i + 1}`,
    img_f: `/src/assets/images/lottery-icons/ficha${i + 1}.svg`,
  })),
};

const useGetLotteryResources = gameId => {
  const {data, isLoading, isSuccess, refetch, error} = useQuery({
    queryKey: ["lottery_resources", gameId],
    queryFn: () => getLotteryResourcesService(gameId),
    enabled: !!gameId,
    staleTime: 5,
    retry: 1,
  });

  // If there's an error or no data, return mock data for development
  const shouldUseMockData = (error || !data) && gameId;

  return {
    data: shouldUseMockData ? mockLotteryData : data?.data?.data,
    isLoading: shouldUseMockData ? false : isLoading,
    isSuccess: shouldUseMockData ? true : isSuccess,
    refetch,
    fichas: shouldUseMockData ? mockLotteryData.fichas : data?.data?.data?.fichas,
    error: shouldUseMockData ? null : error,
  };
};

export default useGetLotteryResources;
